import { useEffect,useRef } from 'react';
import { AutoSizer,List, WindowScroller } from 'react-virtualized';

import useIsFirstRender from "@/hooks/useIsFirstRender";
import useScreenSize from "@/hooks/useScreenSize";
import ArtlistCard from "@/shared-components/cards/components/ArtlistCard";
import InfiniteScroll from '@/shared-components/lists/components/InfiniteScroll';

import "./styles/VirtualList.css";

export default function VirtualList({ items, onLoadMore, fromSearch }) {
  const listRef = useRef();
  const screenSize = useScreenSize();
  const listSizes = useRef(computeListSizes());
  const isFirstRender = useIsFirstRender();

  function computeListSizes() {
    const widthOfContainer = screenSize.width <= 650 ? screenSize.width-30 : screenSize.width <= 1004 ? screenSize.width-40 : screenSize.width <= 1400 ? screenSize.width-60 : Math.min(1720, screenSize.width - 80);
    const spacer = screenSize.width <= 600 ? 10 : 15;
    const columnsPerRow = screenSize.width <= 692 ? 2 : screenSize.width <= 1100 ? 3 : screenSize.width <= 1500 ? 4 : 5;
    const columnWidth = (widthOfContainer - (columnsPerRow-1)*spacer) / columnsPerRow;
    const rowHeight = !fromSearch ? computeRowHeight(columnWidth, spacer) : computeRowHeight(columnWidth, spacer)  + 20;

    return { columnWidth, columnsPerRow, rowHeight };
  }

  function computeRowHeight(columnWidth, spacer) {
    const heightOfImage = columnWidth*0.65;
    if(screenSize.width <= 450) return heightOfImage + spacer + 125;
    else if(screenSize.width <= 1004) return heightOfImage + spacer + 150;
    else return heightOfImage + spacer + 150;
  }

  useEffect(()=>{
    if(!isFirstRender) {
      listSizes.current = computeListSizes();
      listRef.current.recomputeRowHeights();
    } 
  }, [screenSize]);

  return (
    <>
      <InfiniteScroll 
        onLoadMore={onLoadMore} 
        shouldLoadMore={items.data.length < items.totalDocs} 
        offsetElements={3} 
        listLength={items.data.length} 
        className="home-artlists__infinite-container"
      >
        {({ infiniteScrollAssigner }) => (
          <WindowScroller>
            {({ height, isScrolling, onChildScroll, scrollTop }) => (
              <AutoSizer disableHeight>
                {({ width }) => {
                  return (
                    <List
                      autoHeight
                      width={width === 0 ? 0.1 : width}
                      height={height}
                      isScrolling={isScrolling}
                      onScroll={onChildScroll}
                      scrollTop={scrollTop}
                      ref={listRef}
                      overscanRowCount={3}
                      rowCount={Math.ceil(items.data.length / listSizes.current.columnsPerRow)}
                      rowHeight={listSizes.current.rowHeight}
                      estimatedRowSize={500}
                      rowRenderer={({ index, key, style }) => {
                        let columns = [];
                        const fromIndex = index * listSizes.current.columnsPerRow;
                        const toIndex = Math.min(fromIndex + listSizes.current.columnsPerRow, items.data.length);
        
                        for(let i=fromIndex; i<toIndex; i++) {
                          columns.push(
                            <ArtlistCard 
                              key={i} 
                              data={items.data[i]} 
                              style={{ width: `${listSizes.current.columnWidth}px` }} 
                              infiniteScrollObserver={infiniteScrollAssigner(i)}
                              fromSearch={fromSearch}
                            />
                          );
                        }
        
                        return (
                          <div 
                            className={"home-artlists-from-search__virtual-row"} 
                            key={key} style={{ ...style, top: style.top + (index * 20) }} >
                            {columns}
                          </div>
                        );
                      }}
                    />
                  );
                }}
              </AutoSizer>
            )}
          </WindowScroller>
        )}
      </InfiniteScroll>
    </>
  );
}